import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { environment } from 'environments/environment';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: NbAuthService, private router: Router) {
  }

  canActivate() {
    return this.authService.isAuthenticated()
      .pipe(
        tap(authenticated => {
          if (!authenticated) {
            if(this.isForQuestionari()){
              this.router.navigate(['auth/login']);

            } else {
              this.router.navigate(['auth/shibboleth']);
            }
          }
        }),
      );
      //return true;
  }

  isForQuestionari(){
    return environment.APIendpoint == 'https://questionariopis.unisa.it:8445' ? true : false;
  }
  
}